import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import Loading from '../../components/Loading';

const ProjectComponent = lazy(
  () => import(/* webpackChunkName: "project" */ '../../pages/project'),
);

const ProjectStatisticComponent = lazy(
  () =>
    import(/* webpackChunkName: "project" */ '../../pages/project/statistic'),
);

const CreateProjectDialogComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "project" */ '../../pages/project/CreateProjectDialog'
    ),
);

const PinLocationDragDialogComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "project" */ '../../components/PinLocationDragDialog'
    ),
);

const ProjectInformationDialogComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "project" */ '../../pages/project/ProjectInformationDialog'
    ),
);

const projectRouter = (
  <Route
    path="project"
    element={
      <Suspense fallback={<Loading />}>
        <ProjectComponent />
      </Suspense>
    }
  >
    <Route path="statistic" element={<ProjectStatisticComponent />} />
    <Route path="create" element={<CreateProjectDialogComponent />}>
      <Route path="pin-location" element={<PinLocationDragDialogComponent />} />
    </Route>
    <Route
      path=":projectId/info"
      element={<ProjectInformationDialogComponent mode="view" />}
    />
    <Route
      path=":projectId/edit"
      element={<ProjectInformationDialogComponent mode="edit" />}
    >
      <Route path="pin-location" element={<PinLocationDragDialogComponent />} />
    </Route>
  </Route>
);

export default projectRouter;
